import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetItemListForModalController::__invoke
* @see app/Http/Controllers/Item/GetItemListForModalController.php
* @route '/api/item-for-modal'
*/
const GetItemListForModalController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemListForModalController.url(options),
    method: 'get',
})

GetItemListForModalController.definition = {
    methods: ["get","head"],
    url: '/api/item-for-modal',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetItemListForModalController::__invoke
* @see app/Http/Controllers/Item/GetItemListForModalController.php
* @route '/api/item-for-modal'
*/
GetItemListForModalController.url = (options?: RouteQueryOptions) => {
    return GetItemListForModalController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetItemListForModalController::__invoke
* @see app/Http/Controllers/Item/GetItemListForModalController.php
* @route '/api/item-for-modal'
*/
GetItemListForModalController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemListForModalController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetItemListForModalController::__invoke
* @see app/Http/Controllers/Item/GetItemListForModalController.php
* @route '/api/item-for-modal'
*/
GetItemListForModalController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemListForModalController.url(options),
    method: 'head',
})

export default GetItemListForModalController